export default __webpack_public_path__ + "static/media/m3.b9c097f7.jpg";